import React, { Component } from 'react';
import axios from "axios";
import CompareRow from './compare-row';

export default class Compare extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	      	types: [],
			date: [],
			reports: [],
			reportsBySource: [],
			countlist: 0,
			countFBList: 0,
			updatedData: false
	    }
	}
	// async getMetrics(daterange, category) {
	//     const range = daterange.map(date => `${date.getFullYear()}-${pad(date.getMonth()+1, 2)}-${pad(date.getDate(),2)}`);
	//     const startDate = range[0];
	//     const endDate = range[1];
	//     if (!category) {
	//       category = "";
	//     }

	//     const url = process.env.REACT_APP_API + "/analytics";

	//     try {
	//       const response = await axios.get(
	//         url,
	//         {
	//           params: {
	//             startDate,
	//             endDate,
	//             category
	//           }
	//         },
	//         {
	//           timeout: 0,
	//           headers: {
	//             "Content-Type": "application/json;charset=utf-8"
	//           }
	//         }
	//       );
	//       let reports = response.data.reports;
	//       const countlist = response.data.countlist;
	//       const countFBList = response.data.countFBList;
	//       // reports[2].data.rows.map((row, idx) => {
	        
	//       // });
	//       reports.push(countlist);
	//       reports.push(countFBList);
	//       return reports;
	      
	//     } catch (error) {
	//       console.error(error);
	//     }
	//   }
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { types, date, reportsBySource, hasReportDataTypes } = nextProps;
		
		this.setState({
	        types,
	        date,
	        reportsBySource
	      });
				
		if (types && hasReportDataTypes 
			&& hasReportDataTypes[hasReportDataTypes.length - 1] 
			&& types[types.length - 1].value === hasReportDataTypes[hasReportDataTypes.length - 1].value && !this.state.updatedData
		) {
			this.setState({updatedData: true});
			this.props.revalidateStaleTypes();
		}
	}

	handleUpdatedDataAnalyticsRow = (data) => {
		if (this.props.showSnackBar) {
			// const cate = this.props.types.find(c => c.value === data.value);
			
			this.props.showSnackBar({ mess: `Thống kê nguồn ${data} vừa mới cập nhật!`, type: "success" });
		}
	}
	
	render() {
		const { types, date, reports, reportsBySource } = this.state;
		// console.log(reportsByCat.length);
		if(reportsBySource.length == 0){
			return (
        		<div className="spinner-border" role="status">
				  <span className="sr-only">Loading...</span>
				</div>
        	);
		}
		else{
			return (
		    	<div className="table-responsive">
	                <table className="m-0 table table-striped table-valign-middle">
	                  <thead>
	                    <tr>
	                      <th>Nguồn</th>
	                      <th>Cùng kì</th>
	                      <th>Hiện tại</th>
	                      <th>Tăng trưởng</th>
	                    </tr>
	                  </thead>
	                  <tbody>
	                    {types && types.map((data,idx) => (
	                    	data != "sum" ?
                    		<CompareRow
								key={`compare-${idx}`}
								data={reportsBySource[data]}
								dataSum={reportsBySource["sum"]}
								currentType={data}
								types={types}
								handleUpdatedData={this.handleUpdatedDataAnalyticsRow}
							/>
							: null
						))}
	                  </tbody>

	                </table>
	            </div>
		    );
		}
	    
	}

}